<script>
import ProspectContactListItem from '@components/prospects/prospect-contact-list-item.vue';
import { prospectComputed } from '@/src/state/helpers';

export default {
  components: {
    ProspectContactListItem,
  },
  props: {
    prospects: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...prospectComputed,
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <ul class="prospect-contact-list">
    <ProspectContactListItem
      v-for="(prospect, i) in prospects"
      :prospect="prospect"
      :key="i"
    />
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.prospect-contact-list {
  margin-bottom: 0;
}
</style>
